// New component: SavedAddresses.js

import React from 'react';

function SavedAddresses({ addresses, onSelectAddress }) {
  return (
    <div className='saved-addresses'>
      <h3>Saved Addresses</h3>
      {addresses.map((address, index) => (
        <div key={index} className='address-card'>
          <p>Name: {address.name}</p>
          <p>Address: {address.address.line1}</p>
          {/* Render other address details as needed */}
          <button onClick={() => onSelectAddress(address)}>Use This Address</button>
        </div>
      ))}
    </div>
  );
}

export default SavedAddresses;
